import { administrationRequests } from "api/administrationApi";
import { createExporter } from "utils/createExporter";
import { ACADEMIC_REQUESTS, ACADEMIC_REQUEST_DATA_ISSUES } from "utils/constants";
import { getDisplayName } from "utils/helpers";
import { AcademicRequestStatus, AcademicRequestTypeChoices } from "utils/choices";
import { accountRequests } from "api/accountApi";

const fileName = ACADEMIC_REQUESTS.replace(/[-/]/g, "_");
const dataIssuesFileName = ACADEMIC_REQUEST_DATA_ISSUES.replace(/[-/]/g, "_");

export const AcademicRequestExporter = createExporter(
  `student_${fileName}.xlsx`,
  [
    { key: "student", label: "студент" },
    { key: "facultyNumber", label: "факултетен номер" },
    { key: "speciality", label: "специалност" },
    { key: "type", label: "тип" },
    { key: "createdOn", label: "създаден" },
    { key: "status", label: "статус" },
  ],
  record => ({
    ...record,
    student: getDisplayName(record.user),
    speciality: record.speciality?.nameBg,
    type: AcademicRequestTypeChoices.find(t => t.id === record.type)?.name ?? "",
    status: AcademicRequestStatus.find(ar => ar.id === record.status)?.name ?? "",
  }),
  [
    {
      source: "userId",
      target: accountRequests.getUsersSelect(),
      name: "user",
    },
    {
      source: "specialityId",
      target: administrationRequests.getSpecialitiesSelect(),
      name: "speciality",
    },
  ],
);

export const AcademicRequestDataIssueExporter = createExporter(
  `student_${dataIssuesFileName}.xlsx`,
  [
    { key: "student", label: "студент" },
    { key: "facultyNumber", label: "факултетен номер" },
    { key: "speciality", label: "специалност" },
    { key: "topicNameBg", label: "тема" },
    { key: "note", label: "забележка" },
    { key: "createdOn", label: "създаден" },
    { key: "status", label: "статус" },
  ],
  record => ({
    ...record,
    student: getDisplayName(record.user),
    speciality: record.speciality?.nameBg,
    status: AcademicRequestStatus.find(ar => ar.id === record.status)?.name ?? "",
  }),
  [
    {
      source: "userId",
      target: accountRequests.getUsersSelect(),
      name: "user",
    },
    {
      source: "specialityId",
      target: administrationRequests.getSpecialitiesSelect(),
      name: "speciality",
    },
  ],
);
